"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatfileClient = void 0;
const cross_env_config_1 = require("@flatfile/cross-env-config");
const url_join_1 = __importDefault(require("url-join"));
const Client_1 = require("../Client");
const environments = __importStar(require("../environments"));
const RecordsClient_1 = require("./RecordsClient");
cross_env_config_1.CrossEnvConfig.alias("FLATFILE_API_URL", "AGENT_INTERNAL_URL");
cross_env_config_1.CrossEnvConfig.alias("FLATFILE_BEARER_TOKEN", "FLATFILE_API_KEY");
class FlatfileClient extends Client_1.FlatfileClient {
    constructor(options = {}) {
        var _a, _b;
        super({
            environment: (_a = resolveEnvironment(options)) !== null && _a !== void 0 ? _a : environmentSupplier,
            token: (_b = options.token) !== null && _b !== void 0 ? _b : tokenSupplier,
        });
    }
    get records() {
        var _a;
        return ((_a = this._records) !== null && _a !== void 0 ? _a : (this._records = new RecordsClient_1.Records(this._options)));
    }
}
exports.FlatfileClient = FlatfileClient;
const resolveEnvironment = (options) => {
    if (options.apiUrl && !options.apiUrl.endsWith("/v1")) {
        return (0, url_join_1.default)(options.apiUrl, "v1");
    }
    return options.environment || options.apiUrl;
};
const environmentSupplier = () => {
    const url = cross_env_config_1.CrossEnvConfig.get("FLATFILE_API_URL");
    if (!url) {
        return environments.FlatfileEnvironment.Production;
    }
    return (0, url_join_1.default)(url, "v1");
};
const tokenSupplier = () => {
    const token = cross_env_config_1.CrossEnvConfig.get("FLATFILE_BEARER_TOKEN");
    if (token == undefined) {
        throw new Error("FLATFILE_BEARER_TOKEN is undefined");
    }
    return token;
};
